




























































import {Component, Mixins} from 'vue-property-decorator';
import {
  CommonModelUtils, TableHeader, WhoddCasListInfo, WhoddCasRetrieveResponse, WhoddCasSelectDialogRequest,
  WhoddSubstanceAiCodeRetrieveResponse,
  WhoddVersionInfo
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import IconButton from '@/components/button/IconButton.vue';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import CaseApi from '@/api/CaseApi';
import AiCodingApi from '@/api/AiCodingApi';
import AiCodingDialogMixin from '@/components/dialog/AiCodingDialogMixin';

@Component({
               components: {TextInput, CommonPromptDialog, CommonPaginatedTable,
                   CommonButton, IconButton, BooleanCheckboxInput},
               mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin, AiCodingDialogMixin]
           })
export default class CaseWhoddCasSelectDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin,
                                                             AiCodingDialogMixin) {
    protected columns: TableHeader[] = [
        {
            columnId: 'substanceName',
            columnLabel: this.$root.$t('message.case.whodd.caseWhoddCasSelectDialog.substanceName').toString(),
            filtered: 'N',
            visible: 'Y'
        },
        {
            columnId: 'casNumber',
            columnLabel: this.$root.$t('message.case.whodd.caseWhoddCasSelectDialog.casNumber').toString(),
            filtered: 'N',
            visible: 'Y'
        }
    ];

    private whoddVersionInfo: WhoddVersionInfo = {
        tableVersion: '',
        shortVersion: '',
        version: ''
    };
    private isKeywordExact: boolean = false;
    private values: WhoddCasListInfo[] = [];
    private targetRowNo2: number = 0;
    private isAiRecommendation: boolean = false;
    private onSelect: (row: WhoddCasListInfo) => void;
    private onCancel: (keyword: string) => void;

    get getTitle() {
        return this.whoddVersionInfo.version;
    }

    get getValues() {
        return this.values;
    }

    get isLoading() {
        return this.loading;
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showCaseWhoddCasSelectDialog', (params: WhoddCasSelectDialogRequest) => {
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideCaseWhoddCasSelectDialog', () => this.close());
    }

    public show(request: WhoddCasSelectDialogRequest) {
        this.whoddVersionInfo = request.whoddVersionInfo;
        this.width = request.width ? request.width : this.DEFAULT_WIDTH;
        this.onSelect = request.onSelect;
        this.onCancel = request.onCancel;
        this.keyword = request.keyword;
        this.maxLength = request.maxLength;

        this.isAiRecommendation = false;
        this.loading = false;

        if (request.isAiCoding) {
            this.isAiRecommendation = true;
            this.keyword = '';
            this.targetRowNo2 = request.rowNo2;
            this.retrieveRecommendedWhoddSubstanceCodes(false)
                .then(() => {
                    this.visible = true;
                    if (this.values.length === 0) {
                        this.retrieveRecommendedWhoddSubstanceCodes(true);
                    }
                });
        } else {
            this.visible = true;
            this.retrieve(1, 10);
        }
    }

    public retrieve(pageNo: number, rowCount: number) {
        this.lastKeyword = this.keyword;

        if (!this.keyword) {
            this.values = [];
            return;
        }

        const params = {pageNo, rowCount, keyword: this.keyword, isKeywordExact: this.isKeywordExact};
        this.loading = true;
        this.isAiRecommendation = false;
        return CaseApi.retrieveWhoddCasCodes(this.whoddVersionInfo.tableVersion, params)
                      .then((res: WhoddCasRetrieveResponse) => {
                          if (!res.success) {
                              return Promise.reject(res.errMsg);
                          }

                          const paginate = CommonModelUtils.getOrDefaultPaginate(res.data);
                          this.values = paginate.listInfo;
                          this.pageInfo = paginate.pageInfo;
                      })
                      .catch((errMsg) => this.afterRequestFail(errMsg))
                      .finally(() => this.loading = false);
    }

    public retrieveRecommendedWhoddSubstanceCodes(shouldUsePooling: boolean) {
        const params = {
            searchText: this.keyword,
            dicVersion: this.whoddVersionInfo.tableVersion,
            countryCode: null,
            shouldUsePooling,
        };
        const caseKey = Number(this.$route.params.caseKey);
        const rowNo = Number(this.$route.params.rowNo);

        this.loading = true;
        return AiCodingApi.retrieveRecommendedWhoddSubstanceCodes(caseKey, rowNo, this.targetRowNo2, params)
            .then((res: WhoddSubstanceAiCodeRetrieveResponse) => {
                return this.handleRetrieveRecommendCodesSuccess(
                    res,
                    data => this.values = data.recommendedCodes,
                    this.close
                );
            })
          .catch(({errMsg, errCode}) => {
            return this.handleRetrieveRecommendCodesError(errMsg, errCode, this.close, this.afterRequestFail);
          }).finally(() => this.loading = false);
    }

    public onInput($event: any) {
        if (this.isKeywordMaxlengthExceed) {
            return;
        }

        this.onRowClick({
                            $event,
                            row: {
                                casNumber: this.keyword,
                                isDirectInput: true
                            }
                        });
    }

    public onRowClick(data: any) {
        const {row, $event} = data;

        if (this.onSelect) {
            this.onSelect(row);
        }

        this.close();
    }

    public close() {
        if (this.onCancel) {
            this.onCancel(this.lastKeyword);
        }
        this.visible = false;
    }

    public afterClosed() {
        this.values = [];
        this.keyword = '';
        this.lastKeyword = '';
        this.isKeywordExact = false;
        this.loading = false;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showCaseWhoddCasSelectDialog');
        this.$modal.getEventBus().$off('hideCaseWhoddCasSelectDialog');
    }
}
